import React from 'react';
import { useVendorAuth } from './VendorAuthProvider';
import VendorLoginPage from './VendorLoginPage';
import { Loader2 } from 'lucide-react';

interface VendorProtectedRouteProps {
  children: React.ReactNode;
}

const VendorProtectedRoute: React.FC<VendorProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useVendorAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="animate-spin h-12 w-12 text-sunbeth-orange-600 mx-auto" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <VendorLoginPage />;
  }

  return <>{children}</>;
};

export default VendorProtectedRoute;

